import { Input, type InputDescriptionProps } from "@mantine/core";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
} & InputDescriptionProps;

export function InputDescription({ children, ...inputDescProps }: Props) {
  const defaultOption: Omit<InputDescriptionProps, "children"> = {};
  const option = Object.assign({}, defaultOption, inputDescProps);
  return <Input.Description {...option}>{children}</Input.Description>;
}
